import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PricingTable } from '@/components/subscription/PricingTable';

function detectCurrency(): string {
  try {
    const lang = navigator.language?.toLowerCase() || '';
    if (lang === 'pt-br' || lang.startsWith('pt-br')) return 'brl';
    if (lang.startsWith('en-us') || lang.startsWith('en-ca')) return 'usd';
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (timezone.startsWith('America/Sao_Paulo') || timezone.startsWith('America/Fortaleza') ||
        timezone.startsWith('America/Recife') || timezone.startsWith('America/Bahia') ||
        timezone.startsWith('America/Belem') || timezone.startsWith('America/Manaus')) {
      return 'brl';
    }
    if (timezone.startsWith('America/') && !timezone.startsWith('America/Sao')) {
      return 'usd';
    }
  } catch {
    // ignore detection errors
  }
  return 'eur';
}

export function LandingPricing() {
  const { t } = useTranslation(['home']);
  const currency = useMemo(() => detectCurrency(), []);

  return (
    <section id="pricing" className="py-16 sm:py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-white">
            {t('home:pricing.sectionTitle')}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-400">
            {t('home:pricing.sectionSubtitle')}
          </p>
        </div>

        <PricingTable
          currency={currency}
          interval="year"
          isSubscribed={false}
          signupMode
        />
      </div>
    </section>
  );
}
